import React from "react";
import { NavLink } from "react-router-dom";
import PlusIcon from "../../../assets/PlusIcon.png";
import Sidebar from "../../../common/Sidebar/Sidebar";
import Edit from "../../../assets/Edit.svg";
import Delete from "../../../assets/Delete.svg";
import "../AdminDashBoard.css";
import { TableContent } from "./data";
const Index = () => {
  return (
    <div className="row">
      <Sidebar />
      {/* <!-- Stash Drop --> */}
      <div className="col-11 TableMax-width mx-auto mt-5 pt-md-4 marginTop10">
        <div className="row">
          <div className="col-md-12">
            <h2 className="TableHeading">Stash Drops</h2>
          </div>
          <div className="col-md-12">
            {/* <!-- Tabs --> */}
            <div className="TabWrapper">
              <ul className="mb-3 StashTabs_Link">
                <ul
                  className="left_SLink nav nav-pills"
                  id="pills-tab"
                  role="tablist"
                >
                  <li className="nav-item" role="presentation">
                    <button
                      className="active"
                      id="pills-Stash1-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-Stash1"
                      type="button"
                      role="tab"
                      aria-controls="pills-Stash1"
                      aria-selected="true"
                    >
                      Upcoming Drops
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className=""
                      id="pills-Stash2-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-Stash2"
                      type="button"
                      role="tab"
                      aria-controls="pills-Stash2"
                      aria-selected="false"
                    >
                      Past Drops
                    </button>
                  </li>
                </ul>
                <ul className="Right_SLink">
                  <li>
                    <button className="CreateBtn">
                      Create Drop
                      <img
                        src={PlusIcon}
                        className="img-fluid ms-2 mt-1"
                        alt=""
                      />
                    </button>
                  </li>
                </ul>
              </ul>
              <div
                className="tab-content StashTabs_Content"
                id="pills-tabContent"
              >
                {/* <!-- 1 Tabs --> */}
                <div
                  className="tab-pane fade show active"
                  id="pills-Stash1"
                  role="tabpanel"
                  aria-labelledby="pills-Stash1-tab"
                >
                  {/* <!-- Table Header --> */}
                  <div className="TableHeader">
                    <div className="row row-cols-7 mx-0">
                      <div className="col-2 ">
                        <span className="">Artist Handle</span>
                      </div>
                      <div className="col-3">
                        <span>Name of Stash Drop </span>
                      </div>
                      <div className="col">
                        <span>Stash Season </span>
                      </div>
                      <div className="col-2">
                        <span>Date & Time (PST) </span>
                      </div>
                      <div className="col">
                        <span>Edition NFT Mint Price </span>
                      </div>
                      <div className="col">
                        <span>Number of NFT Editions </span>
                      </div>
                      <div className="col-1">
                        <span>Options</span>
                      </div>
                    </div>
                  </div>
                  {/* <!-- Table Content --> */}
                  {TableContent.map((item) => {
                    const ArtistImg = require(`../../../assets/${item.ArtistImg}`);
                    const StashImg = require(`../../../assets/${item.StashImg}`);
                    return (
                      <div className="TableContent">
                        <div className="row row-cols-7 mx-0">
                          <div className="col-2">
                            <img
                              src={ArtistImg}
                              className="img-fluid me-3"
                              alt=""
                            />
                            <span className="img-txt">{item.ArtistName}</span>
                          </div>
                          <div className="col-3">
                            <img
                              src={StashImg}
                              className="img-fluid me-3"
                              alt=""
                            />
                            <span className="fw-bold">{item.StashName}</span>
                          </div>
                          <div className="col">
                            <span>{item.Season}</span>
                          </div>
                          <div className="col-2">
                            <span>{item.Date}</span>
                          </div>
                          <div className="col">
                            <span>{item.EditionNFT}</span>
                          </div>
                          <div className="col">
                            <span>{item.NumberEdition}</span>
                          </div>
                          <div className="col-1">
                            <span className="me-4">
                              <NavLink to="">
                                <img
                                  src={Delete}
                                  className="img-fluid"
                                  alt=""
                                />
                              </NavLink>
                            </span>
                            <span>
                              <NavLink to="">
                                <img src={Edit} className="img-fluid" alt="" />
                              </NavLink>
                            </span>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                  {/* <!-- Table Footer --> */}
                  <div className="TableFooter">
                    <div className="row mx-0 justify-content-between">
                      <div className="col-3">
                        <button className="btn Btn_Previous">Previous</button>
                      </div>
                      <div className="col-3 d-flex justify-content-center">
                        <span className="Page_txt">Page 1 of 10</span>
                      </div>
                      <div className="col-3 d-flex justify-content-end">
                        <button className="btn Btn_Previous">Next</button>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <!-- 2 Tabs --> */}
                <div
                  className="tab-pane fade"
                  id="pills-Stash2"
                  role="tabpanel"
                  aria-labelledby="pills-Stash2-tab"
                >
                  {/* <!-- Table Header --> */}
                  <div className="TableHeader">
                    <div className="row row-cols-7 mx-0">
                      <div className="col-2">
                        <span className="">Artist Handle</span>
                      </div>
                      <div className="col-3">
                        <span>Name of Stash Drop </span>
                      </div>
                      <div className="col">
                        <span>Stash Season </span>
                      </div>
                      <div className="col-2">
                        <span>Date & Time (PST) </span>
                      </div>
                      <div className="col">
                        <span>Edition NFT Mint Price </span>
                      </div>
                      <div className="col">
                        <span>Number of NFT Editions </span>
                      </div>
                      <div className="col-1">
                        <span>Options</span>
                      </div>
                    </div>
                  </div>
                  {/* <!-- Table Content --> */}
                  {TableContent.map((item) => {
                    const ArtistImg = require(`../../../assets/${item.ArtistImg}`);
                    const StashImg = require(`../../../assets/${item.StashImg}`);
                    return (
                      <div className="TableContent">
                        <div className="row row-cols-7 mx-0">
                          <div className="col-2">
                            <img
                              src={ArtistImg}
                              className="img-fluid me-3"
                              alt=""
                            />
                            <span className="img-txt">{item.ArtistName}</span>
                          </div>
                          <div className="col-3">
                            <img
                              src={StashImg}
                              className="img-fluid me-3"
                              alt=""
                            />
                            <span>{item.StashName}</span>
                          </div>
                          <div className="col">
                            <span>{item.Season}</span>
                          </div>
                          <div className="col-2">
                            <span>{item.Date}</span>
                          </div>
                          <div className="col">
                            <span>{item.EditionNFT}</span>
                          </div>
                          <div className="col">
                            <span>{item.NumberEdition}</span>
                          </div>
                          <div className="col-1">
                            <span className="me-4">
                              <NavLink to="">
                                <i
                                  className="fa fa-trash-o"
                                  aria-hidden="true"
                                ></i>
                              </NavLink>
                            </span>
                            <span>
                              <NavLink to="">
                                <i
                                  className="fa fa-pencil"
                                  aria-hidden="true"
                                ></i>
                              </NavLink>
                            </span>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                  {/* <!-- Table Footer --> */}
                  <div className="TableFooter">
                    <div className="row mx-0 justify-content-between">
                      <div className="col-3">
                        <button className="btn Btn_Previous">Previous</button>
                      </div>
                      <div className="col-3 d-flex justify-content-center">
                        <span className="Page_txt">Page 1 of 10</span>
                      </div>
                      <div className="col-3 d-flex justify-content-end">
                        <button className="btn Btn_Previous">Next</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <!--ENd Tabs --> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Index;
